<template>
  <b-list-group-item :to="to" :variant="bgVariant">
    <b-row>

      <b-col cols="3" align-h="center"><h1>{{number}}</h1></b-col>
      <b-col cols="6" align-h="center">{{text}}</b-col>
      <b-col cols="3" align-h="center" class="section-status-indicators" v-if="id !== '5'">
        <b-row class="h-100" align-v="center" align-h="center">
          <b-badge :variant="badgeVariant"
                   :id="'badge' + number"
                   class="badge">
            <font-awesome-icon :icon="['far', 'check']"/>
          </b-badge>
          <b-popover :target="'badge' + number"
                     triggers="hover"
                     :content="popoverText"/>
        </b-row>
      </b-col>
    </b-row>
  </b-list-group-item>
</template>

<script>
  import { mapState } from "vuex";

  import { createNamespacedHelpers, mapGetters } from 'vuex'
  const { mapMutations, mapActions } = createNamespacedHelpers('rx');

  export default {
    name: "ProjectSectionNav",
    props: ['text', 'number', 'to', 'id'],
    computed: {
      ...mapState({
        section: state => state.rx.currentProjectIsValid.section,
        isValid: state => state.rx.currentProjectIsValid.section
      }),

      ...mapGetters('rx',['projectIsValid']),

      badgeVariant(){
        if (this.section[this.id]){
          return 'success'
        } else {
          return 'warning'
        }
      },
      bgVariant(){
        return 'light-blue'
      },
      linkTo(){
        if ('id'==='5' && this.section[this.id]){
          return this.to
        } else if ('id'==='5' && !this.section[this.id]){
          // Don't make report available if project isn't valid
          return null
        } else {
          return this.to
        }
      },
      dataIsValid(){
        return this.section[this.id]
      },
      dataIsSaved(){
        return false
      },
      popoverText(){
        const v = this.dataIsValid ? "Valid" : "Incomplete";
        const validityText = "" + v;
        // const savedText = "" + (this.dataIsSaved ? "saved": "not saved");
        // return validityText + '\n' + savedText
        return validityText
      }
    },
  }
</script>

<style scoped>
  h1 {
    margin: 0;
  }
  .section-status-indicators{
    text-align: center;
  }

  .badge {
    border-style: solid;
    border-width: .2em;
    /*border-color: red;*/
  }

</style>